/**
 * @return an instance with `unregisterWatcher` which you can use to unregister the event listeners
 */
export default ({
  onOffline,
  onOnline,
}) => {
  window.addEventListener('offline', onOffline);
  window.addEventListener('online', onOnline);

  return {
    unregisterWatcher: () => {
      window.addEventListener('offline', onOffline);
      window.addEventListener('online', onOnline);
    },
  };
};



// WEBPACK FOOTER //
// ./src/libs/onlineWatcher.js